// src/pages/Search/Search.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ProductSkeleton } from "../common/ProductSkeleton";
import Product from "../../container/Product/Product";

const Search = () => {
  const { query } = useParams();
  const searchQuery = (query || "").trim();

  const {
    data: searchProduct,
    isPending,
    isError,
    error,
  } = useQuery({
    queryKey: ["search", searchQuery],
    enabled: Boolean(searchQuery),
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/products/search?q=${encodeURIComponent(
          searchQuery
        )}`
      );

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || "Something went wrong");
      return data;
    },
  });

  const products = searchProduct?.products ?? [];

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 py-6 sm:py-10">
        <div className="mb-4 sm:mb-6">
          <h1 className="text-lg sm:text-2xl font-bold text-gray-900">
            Search Results
          </h1>
          <p className="text-sm text-gray-500 mt-1 break-words">
            Showing results for:{" "}
            <span className="font-semibold text-gray-900">
              {searchQuery || "—"}
            </span>
          </p>
        </div>

        {/* Loading */}
        {isPending && (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {Array.from({ length: 8 }).map((_, i) => (
              <ProductSkeleton key={i} />
            ))}
          </div>
        )}

        {/* Error */}
        {isError && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sm:p-6">
            <p className="text-sm text-red">{error?.message}</p>
          </div>
        )}

        {/* Empty */}
        {!isPending && !isError && products.length === 0 && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 text-center">
            <p className="text-gray-700 font-semibold">No products found</p>
            <p className="text-sm text-gray-500 mt-1">
              Try searching with a different keyword.
            </p>
          </div>
        )}

        {/* Results */}
        {!isPending && !isError && products.length > 0 && (
          <div>
            <Product products={products} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Search;
